import React from "react";

const GridContext = React.createContext({});

const FilterContextProvider = GridContext.Provider;
const GridContextConsumer = GridContext.Consumer;
export { GridContext as default, FilterContextProvider, GridContextConsumer };
